export const ACTIONS_LICENSE_JOURNAL = {
  INVALIDATE: 'LICENSE_JOURNALS_INVALIDATE',
  RECEIVE: 'LICENSE_JOURNALS_RECEIVE',
  DELETE: 'LICENSE_JOURNAL_DELETE',
  UPDATE: 'LICENSE_JOURNAL_UPDATE',
};

const licenseJournalConstants = {};

export default licenseJournalConstants;
